import { useImmer } from "use-immer";
import { supportTicket, supportTicketForCertificate } from "..";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { successMessage, errorFormatter } from "utils";

const initialState = {
  name: "",
  registrationId: "",
  email: "",
  phonenumber: "",
  subject: "",
  message: "",
};

export const useSupportTicket = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useImmer(false);
  const [ticketValues, setTicketValues] = useImmer(initialState);

  const supportTickets = useMutation({
    mutationFn: supportTicket,
    onSuccess: () => {
      successMessage("Support ticket has been submitted!");
      navigate("/", { replace: true });
    },
    onError: (data) => {
      errorFormatter(data);
    },
  });

  const supportTicketsForCertificate = useMutation({
    mutationFn: supportTicketForCertificate,
    onSuccess: () => {
      successMessage("Support ticket has been raised!");
      navigate("/program", { replace: true });
    },
    onError: (data) => {
      errorFormatter(data);
    },
  });

  return {
    ticketValues,
    setTicketValues,
    supportTickets,
    isModalOpen,
    setIsModalOpen,
    supportTicketsForCertificate,
  };
};
